(ns frontend.view.settings2.surveys.question-selector
  (:require
   [common.localization :as loc]
   [common.schema.entities.survey.survey-question.options :as survey-question-options]
   [common.util :as cu]
   [frontend.view.settings2.surveys.events :as events]
   [frontend.view.settings2.surveys.sub :as sub]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.components.input.checkbox-group :as checkbox-group]
   [ui.components.modal.style :as modal-style]
   [ui.components.modal.view :as modal]
   [ui.components.radio-group.view :as radio-group]
   [ui.components.text.view :as text]
   [ui.editors.data-input :as data-input]))

(def data-type-options
  (->> survey-question-options/supported-data-types
       (mapv (fn [k]
               {:value k
                :label (loc/tr k)}))
       (sort-by :label)))

(defn data-type-selector
  []
  (let [selected-types @(rf/subscribe [::sub/question-search-data-types])]
    [checkbox-group/view
     {:value       selected-types
      :options     data-type-options
      :horizontal? true
      :on-change   (fn [updated-selected]
                     (rf/dispatch [::events/set-question-search-data-types updated-selected]))}]))

(defn selector-body
  []
  (let [search-str @(rf/subscribe [::sub/question-search-str])
        lang :ENG
        tenant-question-matches @(rf/subscribe [::sub/tenant-question-search-results])
        selected-questions @(rf/subscribe [::sub/selected-questions])
        selected-ids (map :db/id selected-questions)]
    [:div
     {:key   (str "question-selector-" lang)
      :class "flex flex-col gap-4 mx-auto w-5xl justify-between"}
     (when (seq selected-questions)
       [:div
        {:class "flex flex-col gap-2"}
        [text/h2
         (loc/tr :selected-questions)]
        (->> selected-questions
             (map (fn [{:keys [db/id] :as q}]
                    {:key (str ::selected-question "-" id)}
                    [:div
                     {:class "flex flex-row gap-2 items-center group"}
                     [:label
                      (get-in q [:survey-question/label-translations :ENG])]
                     [:span
                      ;{:class "invisible group-hover:visible"}
                      [button/secondary-open
                       {:on-click (fn [_]
                                    (rf/dispatch [::events/remove-question id]))
                        :class    "py-1"}
                       [:i.fal.fa-trash-alt]]]]))
             (doall))])
     [text/h2
      (loc/tr :filter-by-data-type)]
     [data-type-selector]

     [:div
      {:class "flex flex-col gap-2"}
      [:label
       {:class "text-semibold"}
       (loc/tr :survey-question-name-search)]
      [data-input/view
       {:data-type   :data.type/text-simple
        :placeholder (loc/tr :placeholder-search-questions)
        :value       search-str
        :on-change   #(rf/dispatch [::events/set-question-search-str %])}]]
     [:div
      {:class "text-semibold"}
      (loc/tr :select-questions-from-existing-set-or-create-new)]
     [:div
      {:class ""}
      [radio-group/view
       {:value     nil
        :options   (->> tenant-question-matches
                        (remove (fn [{:keys [db/id]}]
                                  (some #{id} selected-ids)))
                        (mapv (fn [{:keys [survey-question/data-type survey-question/data-unit] :as q}]
                                {:label [:div
                                         {:class "flex flex-col gap-1"}
                                         [:span
                                          {}
                                          (get-in q [:survey-question/label-translations :ENG])]
                                         [:div
                                          {:class "flex gap-2 text-xs text-base-light-text-paler"}
                                          [:span
                                           (loc/tr data-type)]
                                          (when-not (cu/blank-value? data-unit)
                                            [:span
                                             {:class "text-semibold"}
                                             data-unit])]]
                                 :value (:db/id q)})))
        :on-change (fn [qid]
                     (let [selected-q (->> tenant-question-matches
                                           (cu/filter-by :db/id qid)
                                           (first))]
                       (rf/dispatch [::events/select-question selected-q])))}]]]))

(defn selector-footer
  []
  (let [selected-questions @(rf/subscribe [::sub/selected-questions])]
    [:div
     {:class "flex flex-row flex-1"}
     [:div
      {:class "flex-1 justify-start"}
      [button/secondary-solid
       {:on-click (fn [_]
                    (rf/dispatch [::events/cancel-select]))}
       (loc/tr :cancel)]]
     [:div
      {:class "flex-1 justify-items-end"}
      [button/primary-solid
       {:disabled? (empty? selected-questions)
        :on-click  (fn [_]
                     (rf/dispatch [::events/add-selected-questions]))}
       (loc/tr :save)]]]))

(defn view
  []
  [modal/view
   {:visible? @(rf/subscribe [::sub/question-selector-open?])
    :hide!    #(rf/dispatch [::events/close-question-selector])
    :z-index  9999
    :size     ::modal-style/full}
   (loc/tr :select-survey-questions)
   [selector-body]
   [selector-footer]])
